import md5 from 'md5';
import * as cookieHelper from './cookieHelper';

const CHATBOT_EMBED_URL = 'https://encyc.ziondaily.com/chatbot/embed.php';
const CHATBOT_AUTH_SECRET = 'YPFYQiNhf5KOYrEifAZQwvCj';

export const isUserLoggedIn = () => {
  const cookies = cookieHelper.getCookie();
  if (!cookies) {
    return false;
  }

  const mid = cookies.zd_mid;
  const token = cookies.zd_token;
  const hasMid = Boolean(mid) && mid !== '' && String(mid) !== '0';
  const hasToken = Boolean(token) && token !== '' && String(token) !== '0';

  return hasMid && hasToken;
};

export const buildChatbotEmbedUrl = (userId, userName) => {
  const mid = userId ?? '';
  const t = Math.floor(Date.now() / 1000);
  const hash = md5(`${mid}${t}${CHATBOT_AUTH_SECRET}`);

  const params = new URLSearchParams({
    mid: String(mid),
    t: String(t),
    hash,
    name: String(userName ?? ''),
  });

  return `${CHATBOT_EMBED_URL}?${params.toString()}`;
};
